import React from "react"
import { Container } from "@bootstrap-styled/v4"
import algoliasearch from "algoliasearch/lite"
import {
  InstantSearch,
  Pagination,
  Configure,
  ScrollTo,
} from "react-instantsearch-dom"

import HitsRow from "src/components/util/HitsRow"
import MenuSearch from "src/components/util/MenuSearch"
import PaginationWrapper from "src/components/util/Pagination"
import Hit from "./Hit"

import * as S from "./styled"

const algolia = {
  appId: process.env.GATSBY_ALGOLIA_APP_ID,
  searchApiKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
  indexName: process.env.GATSBY_ALGOLIA_INDEX_PROJS,
}

const searchClient = algoliasearch(algolia.appId, algolia.searchApiKey)

const ProjetosList = () => {
  return (
    <S.ProjetosListWrapper>
      <Container>
        <InstantSearch
          searchClient={searchClient}
          indexName={algolia.indexName}
        >
          <ScrollTo scrollOn="page"></ScrollTo>

          <Configure hitsPerPage={8} />

          <MenuSearch attribute="category" />

          <S.ProjetosListContent>
            <HitsRow Hit={Hit} />
          </S.ProjetosListContent>

          <PaginationWrapper>
            <Pagination
              showNext={false}
              showPrevious={false}
              showFirst={false}
              showLast={false}
              translations={{
                page(currentRefinement) {
                  return currentRefinement
                },
                ariaPrevious: "Página anterior",
                ariaNext: "Próxima página",
                ariaFirst: "Primeira página",
                ariaLast: "Última pagina",
                ariaPage(currentRefinement) {
                  return `Página ${currentRefinement}`
                },
              }}
            />
          </PaginationWrapper>
        </InstantSearch>
      </Container>
    </S.ProjetosListWrapper>
  )
}

export default ProjetosList
